import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
type ProductPriceDefaultProps = {
  className?: string;
  originalPrice?: string;
  price: string;
};
export function ProductPriceDefault(t0) {
  const $ = _c(12);
  const {
    className,
    originalPrice,
    price
  } = t0;
  const screenReaderText = originalPrice ? `Sale price ${price} original price ${originalPrice}` : `Price is ${price}`;
  let t1;
  if ($[0] !== className || $[1] !== originalPrice) {
    t1 = cn("sparky-c-price", className, {
      "sparky-c-price__strike-group": originalPrice
    });
    $[0] = className;
    $[1] = originalPrice;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== screenReaderText) {
    t2 = <span className="visually-hidden">{screenReaderText}</span>;
    $[3] = screenReaderText;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== originalPrice || $[6] !== price) {
    t3 = originalPrice ? <div className="sparky-c-price--data"><span aria-hidden="true" className="sparky-c-price--sale">{price}</span><span aria-hidden="true" className="sparky-c-price--disabled">{originalPrice}</span></div> : <span aria-hidden="true" className="sparky-c-price">{price}</span>;
    $[5] = originalPrice;
    $[6] = price;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}